import { render } from "./ServiceOrderData.vue?vue&type=template&id=66ca8c8c"
import script from "./ServiceOrderData.vue?vue&type=script&lang=js"
export * from "./ServiceOrderData.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__